import React, { useEffect, useState, useContext } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import brLocale from 'date-fns/locale/pt-BR';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Button, Grid, TextField, Checkbox, FormControlLabel, Dialog, DialogTitle, DialogContent, DialogActions, Divider } from '@material-ui/core';
import Typography from "@material-ui/core/Typography";
import api from '../../services/api';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import './button.css';
import { i18n } from '../../translate/i18n';
import { AuthContext } from "../../context/Auth/AuthContext";
import {  useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.padding,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(2),
    },

    chartFilter: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: theme.spacing(1),
        margin: 0,
        marginBottom: theme.spacing(2),
        fontFamily: '"Poppins", sans-serif',
        color: theme.mode === 'light' ? '#1D1D1F' : '#c0cad9',
    },

        buttonFilter: {
        border: `1px solid ${theme.mode === 'light' ? '#e5e5e5' : '#1D1D1F'}`,
        color: theme.mode === 'light' ? '#1D1D1F' : '#c0cad9',
        lineHeight: 1,
    },
}));

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

export const ChartsDate = () => {
    const theme = useTheme();
    const classes = useStyles();
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [initialDate2, setInitialDate2] = useState(new Date());
    const [finalDate2, setFinalDate2] = useState(new Date());
    const [compare, setCompare] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [ticketsData, setTicketsData] = useState({ data: [], count: 0 });
    const [ticketsData2, setTicketsData2] = useState({ data: [], count: 0 });
    const { user } = useContext(AuthContext);

    const companyId = user.companyId;

    useEffect(() => {
        if (companyId) {
            handleGetTicketsInformation();
        }
    }, [companyId]);

    const handleGetTicketsInformation = async () => {
        try {
            const { data } = await api.get(`/dashboard/ticketsDay?initialDate=${format(initialDate, 'yyyy-MM-dd')}&finalDate=${format(finalDate, 'yyyy-MM-dd')}&companyId=${companyId}`);
            setTicketsData(data);

            if (compare) {
                const { data: data2 } = await api.get(`/dashboard/ticketsDay?initialDate=${format(initialDate2, 'yyyy-MM-dd')}&finalDate=${format(finalDate2, 'yyyy-MM-dd')}&companyId=${companyId}`);
                setTicketsData2(data2);
            } else {
                setTicketsData2({ data: [], count: 0 });
            }
        } catch (error) {
            toast.error('Erro ao buscar informações dos tickets');
        }
    }

    const maxLen = Math.max(ticketsData?.data?.length || 0, ticketsData2?.data?.length || 0);
    const labels = Array.from({length: maxLen}, (_, i) => {
        if (compare) return `Ponto ${i+1}`;
        const item = ticketsData?.data[i];
        return item ? (item.hasOwnProperty('horario') ? `Das ${item.horario}:00 as ${item.horario}:59` : item.data) : '';
    });

    const datasets = [
        {
            label: compare ? 'Total (Período 1)' : 'Total',
            data: Array.from({length: maxLen}, (_, i) => ticketsData?.data[i]?.total || 0),
            backgroundColor: theme.palette.primary.main,
            borderRadius: { topLeft: 8, topRight: 8 },
        }
    ];

    if (compare) {
        datasets.push({
            label: 'Total (Período 2)',
            data: Array.from({length: maxLen}, (_, i) => ticketsData2?.data[i]?.total || 0),
            backgroundColor: '#FF9800',
            borderRadius: { topLeft: 8, topRight: 8 },
        });
    }

    const dataCharts = {
        labels,
        datasets,
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                display: compare,
                font: {
                    size: 10,
                    weight: "bold",
                    family: "'Poppins', sans-serif"
                },
            },
            title: {
                display: true,
                text: 'Tickets',
                position: 'left',
                font: {
                    size: 10,
                    weight: "bold",
                    family: "'Poppins', sans-serif"
                },
            },
            datalabels: {
                display: true,
                anchor: 'end',
                align: "bottom",
                color: "#ffffff",
                font: {
                    size: 10,
                    weight: "bold",
                    family: "'Poppins', sans-serif"
                },
            },
            tooltip: {
                callbacks: {
                    title: (context) => {
                        const index = context[0].dataIndex;
                        if (compare) {
                            const item1 = ticketsData?.data[index];
                            const item2 = ticketsData2?.data[index];
                            const l1 = item1 ? (item1.hasOwnProperty('horario') ? `${item1.horario}h` : item1.data) : 'N/A';
                            const l2 = item2 ? (item2.hasOwnProperty('horario') ? `${item2.horario}h` : item2.data) : 'N/A';
                            return `Ponto ${index+1} (${l1} vs ${l2})`;
                        }
                        return context[0].label;
                    }
                }
            }
        },
    };

    return (
        <>
            <div className={classes.chartFilter}>
                <Typography component="h2" variant="h6" color="theme.mode === 'light' ? '#1D1D1F' : '#c0cad9'" gutterBottom style={{ margin: 0 }}>
                    {i18n.t("dashboard.users.totalAttendances")} ({ticketsData?.count})
                </Typography>
                <Button className={classes.buttonFilter} onClick={() => setOpenModal(true)}>
                    <i className="ri-filter-3-line" style={{ marginRight: 8 }}></i> Filtros
                </Button>
            </div>

            <Dialog open={openModal} onClose={() => setOpenModal(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Filtros de Período</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                                <DatePicker
                                    value={initialDate}
                                    onChange={(newValue) => setInitialDate(newValue)}
                                    label={i18n.t("dashboard.date.initialDate")}
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={brLocale}>
                                <DatePicker
                                    value={finalDate}
                                    onChange={(newValue) => setFinalDate(newValue)}
                                    label={i18n.t("dashboard.date.finalDate")}
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>

                    <Divider style={{ margin: '24px 0' }} />

                    <FormControlLabel
                        control={<Checkbox checked={compare} onChange={(e) => setCompare(e.target.checked)} color="primary" />}
                        label="Comparar Períodos"
                    />

                    {!compare && (
                        <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                            Data atual: {format(new Date(), 'dd/MM/yyyy')}
                        </Typography>
                    )}

                    {compare && (
                        <Grid container spacing={2} style={{ marginTop: 8 }}>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth type="date" label="Data Inicial (Comparação)" InputLabelProps={{ shrink: true }} value={format(initialDate2, 'yyyy-MM-dd')} onChange={(e) => { if(e.target.value) setInitialDate2(new Date(e.target.value + 'T00:00:00')) }} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField fullWidth type="date" label="Data Final (Comparação)" InputLabelProps={{ shrink: true }} value={format(finalDate2, 'yyyy-MM-dd')} onChange={(e) => { if(e.target.value) setFinalDate2(new Date(e.target.value + 'T00:00:00')) }} />
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions style={{ padding: 16 }}>
                    <Button onClick={() => setOpenModal(false)}>Cancelar</Button>
                    <Button onClick={() => { handleGetTicketsInformation(); setOpenModal(false); }} color="primary" variant="contained" style={{ color: '#fff' }}>
                        Aplicar Filtro
                    </Button>
                </DialogActions>
            </Dialog>
            <Bar options={options} data={dataCharts} style={{ maxWidth: '100%', maxHeight: '280px', }} />
        </>
    );
}